









import { defineComponent } from "@vue/composition-api";
import BaseIcon from "@/components/Base/BaseIcon";
import BaseButton from "@/components/BaseButton";

export default defineComponent({
  name: "CreatePostButtonView",
  components: { BaseButton, BaseIcon },
  props: {
    loading: { type: Boolean, required: true },
  },
  setup(_, { emit }) {
    const onClick = () => {
      emit("click");
    };

    return { onClick };
  },
});
